import { Flex, Heading, Text } from "@chakra-ui/react";
import { FieldTemplateProps } from "@rjsf/utils";

import { InfoPopover } from "./info-popover";

export const FormEnumExplanation = (props: FieldTemplateProps) => {
  const { schema, uiSchema } = props;
  const options =
    schema.enum?.map((option, idx) => ({
      value: option + "",
      label: (uiSchema?.["ui:enumNames"]?.[idx] ?? option) + "",
      imbroAOnly: uiSchema?.["ui:enumImbroAOnly"]?.[idx] ?? false,
    })) || [];

  const hideOptionsInfo =
    !options.length || options.every(({ label, value }) => !label || label === value);

  if (hideOptionsInfo) return null;

  return (
    <InfoPopover w="fit-content">
      <Flex position="relative" mx="5" justifyContent="center">
        <Heading as="h6" bg="white" fontSize="lg" textAlign="end" mr="5" w="full">
          Label
        </Heading>
        <Heading as="h6" fontSize="lg" ml="5" w="full">
          Waarde
        </Heading>
      </Flex>
      {options.map(({ value, label, imbroAOnly }) => {
        return (
          <Flex justifyContent="center" key={label + value + "info"} pos="relative">
            <Text whiteSpace="nowrap" w="full" mr="5" textAlign="end" title={label}>
              {label || value}
            </Text>
            {imbroAOnly && (
              <Text
                pos="absolute"
                left="50%"
                transform="translate(-50%, 15%)"
                fontWeight={600}
                title="Alleen mogelijk als kwaliteits regime IMBRO/A is"
              >
                *
              </Text>
            )}
            <Text whiteSpace="nowrap" w="full" ml="5" title={value}>
              {value}
            </Text>
          </Flex>
        );
      })}
      <Text fontSize="xs" pt="3">
        * Betekent dat deze optie alleen mogelijk is als kwaliteits regime IMBRO/A is
      </Text>
    </InfoPopover>
  );
};
